import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '导航',
    links: [
      { label: '首页', path: '/' },
      { label: '恋爱漫画', path: '/category?tag=romance' },
      { label: '悬疑漫画', path: '/category?tag=suspense' },
      { label: '排行榜', path: '/category?sort=popular' },
      { label: '关于我们', path: '/about' },
    ],
  },
  {
    title: '关注我们',
    links: [
      { label: '微博', path: '#', icon: 'ri-weibo-line' },
      { label: '微信公众号', path: '#', icon: 'ri-wechat-line' },
      { label: 'Bilibili', path: '#', icon: 'ri-bilibili-line' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-full bg-background-50/20 flex items-center justify-center">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">
                韩漫网
              </span>
            </Link>
            <p className="text-background-50/70 text-sm leading-relaxed">
              韩漫画免费 · 全集大全<br />
              下拉式阅读 · 零广告体验
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-background-50 font-semibold text-sm mb-4">
                {group.title}
              </h3>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-background-50/60 hover:text-background-50 text-sm transition-colors duration-200 flex items-center gap-2"
                    >
                      {link.icon && (
                        <i className={`${link.icon} text-base`}></i>
                      )}
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="text-background-50 font-semibold text-sm mb-4">
              订阅更新
            </h3>
            <p className="text-background-50/60 text-sm mb-3">
              获取最新漫画资讯，不错过任何更新
            </p>
            <form
              className="flex gap-2"
             
              onSubmit={(e) => e.preventDefault()}
            >
              <input
                type="email"
                name="email"
                placeholder="输入邮箱"
                className="flex-1 bg-background-50/10 border border-background-50/20 rounded-lg px-3 py-2 text-sm text-background-50 placeholder:text-background-50/40 outline-none focus:border-background-50/40 transition-colors"
              />
              <button
                type="submit"
                className="w-10 h-10 rounded-lg bg-accent-500 hover:bg-accent-600 flex items-center justify-center transition-colors duration-200 flex-shrink-0"
                aria-label="订阅"
              >
                <i className="ri-arrow-right-line text-background-50"></i>
              </button>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-50/50 text-xs">
            &copy; 2025 韩漫网 HanMan. All rights reserved.
          </p>
          <p className="text-background-50/40 text-xs">
            致力于提供最佳韩漫阅读体验 · 全站免费 · 每日更新
          </p>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '韩漫网',
            url: 'http://bwpntxx.cn/',
            description: '韩漫画免费全集大全，下拉式无广告阅读，随时随地畅享各种漫画内容',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'http://bwpntxx.cn/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </footer>
  );
}